var pug = require("!../../../../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"search-result-item\"\u003E\u003Cng-include src=\"item.templateUrl\"\u003E\u003C\u002Fng-include\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;